export default __webpack_public_path__ + "static/media/orange-planet.5cd9666d.png";